<template>
  <div class="soundSet-pane" @keydown.stop>
    <div class="tabTitle">
      <p class="">设置</p>
    </div>
    <div style="height: 100%; position: relative">
      <p class="noMUsic">未选中任何元素</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({}),
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.noMUsic {
  width: 100%;
  color: #474261;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  top: 40%;
  position: absolute;
}
.soundSet-pane {
  background-color: #ffffff;
  height: 100%;
}

.tabTitle {
  height: 46px;
  line-height: 46px;
  text-align: left;
  border-bottom: 2px solid #d4d4e7;
  p {
    text-align: center;
    width: 50%;
    height: 46px;
    background-color: #ffffff;
    border-bottom: 2px solid #5778fb;
    color: #474261;
    font-weight: bold;
  }
}
</style>

 



// WEBPACK FOOTER //
// src/components/subtitle/noSelectSet.vue